__turbopack_context__.v({
  "GroupTitle": "LinkColumns-module-scss-module__Ob3veW__GroupTitle",
  "LinkColumn": "LinkColumns-module-scss-module__Ob3veW__LinkColumn",
  "Links": "LinkColumns-module-scss-module__Ob3veW__Links",
  "MenuGroup": "LinkColumns-module-scss-module__Ob3veW__MenuGroup",
  "NavGroup": "LinkColumns-module-scss-module__Ob3veW__NavGroup",
  "NavGroupNarrow": "LinkColumns-module-scss-module__Ob3veW__NavGroupNarrow",
  "RowDivider": "LinkColumns-module-scss-module__Ob3veW__RowDivider",
  "SimpleLink": "LinkColumns-module-scss-module__Ob3veW__SimpleLink",
});
